import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AbstractApiGuardService } from '../abstract.api-guard.service';
import { RealEstateTypeModel } from '../../../shared/models/real-estate-type.model';

@Injectable({
    providedIn: 'root',
})
export class RealEstateTypesService extends AbstractApiGuardService {
    // Using relative URL (host configured elsewhere, e.g., via proxy or deployment base href)
    private readonly apiUrl = `${environment.apiVersionString}/real_estate_types`;

    // Create an application
    create(application: RealEstateTypeModel): Observable<RealEstateTypeModel> {
        return this.post(this.apiUrl, application);
    }

    // Read all applications
    getAll(): Observable<RealEstateTypeModel[]> {
        return this.get(this.apiUrl);
    }

    // Read a single application by ID
    getById(id: string): Observable<RealEstateTypeModel> {
        return this.get(`${this.apiUrl}/${id}`);
    }

    // Update an application
    updateById(id: string, application: RealEstateTypeModel): Observable<RealEstateTypeModel> {
        return this.put(`${this.apiUrl}/${id}`, application);
    }

    // Delete an application
    deleteById(id: string): Observable<void> {
        return this.delete(`${this.apiUrl}/${id}`);
    }
}
